import { useTranslation } from "react-i18next";

import classNames from "../../../utils/classNames";

export type TriState = "any" | "with" | "without";

interface ITriToggleInputProps {
  label: string;
  value: TriState | undefined;
  onChange: (next: TriState) => void;
  disabled?: boolean;
}

const triToggleSegments: { value: TriState; label: string }[] = [
  { value: "any", label: "Any" },
  { value: "with", label: "With" },
  { value: "without", label: "Without" },
];

export default function TriToggleInput({
  label,
  value,
  onChange,
  disabled = false,
}: ITriToggleInputProps) {
  const { t } = useTranslation("common");
  const selectedValue = value ?? "any";

  return (
    <div className="flex flex-col">
      <span className="text-sm font-medium text-black">{label}</span>
      <div
        role="group"
        aria-label={label}
        className={classNames("mt-1 inline-flex rounded-md border border-gray-300 bg-white p-0.5", disabled ? "opacity-50" : "")}
      >
        {triToggleSegments.map((seg) => {
          const active = selectedValue === seg.value;
          return (
            <button
              key={seg.value}
              type="button"
              disabled={disabled}
              onClick={() => onChange(seg.value)}
              className={classNames(
                "rounded-[5px] px-2.5 py-1 text-xs font-medium transition-colors whitespace-nowrap",
                active ? "bg-primary-600 text-white shadow-sm" : "text-gray-600 hover:bg-gray-100",
                disabled ? "cursor-not-allowed" : "cursor-pointer"
              )}
              aria-pressed={active}
            >
              {t(seg.label)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
